import styled from 'styled-components';

export const CMFBlockWrapper = styled('div')`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    column-gap: 16px;
    row-gap: 8px;
    width: 330px;
`;

export const LowEmittingText = styled('div')`
    font-family: 'Proxima Nova' !important;
    font-weight: 400 !important;
    font-size: 11.1px !important;
    line-height: 13.75px !important;
    margin-bottom: 16px !important;
`;